export default "__VITE_ASSET__449a3530__"